<template functional>
  <!-- <v-card 
    @click="$router.push({name: 'UserTop', params: {id: props.r.user.uid}, query: {p: 'rank'}})"
    style="border-radius:10px;width:200px;height:120px;text-align:left;"
  > -->
  <v-card 
    @click="listeners['onRankClick'](props.r.user.uid)"
    style="border-radius:10px;width:200px;height:120px;text-align:left;"
  >
    <v-container style="z-index:5;position:relative;padding-top:40px;">
      <v-layout row wrap style="padding-top:8px;display:table;">
        <v-flex xs4>
          <v-avatar size="50" style="z-index:2;">
            <v-img :src="props.r.user.imageurl" :lazy-src="require('@/assets/img/person_icon.png')"/>
          </v-avatar>
        </v-flex>
        <v-flex xs8 style="font-size:12pt;font-weight:bold;display: table-cell;vertical-align: middle;padding-left:8px;"> 
          {{props.r.user.displayName}}
        </v-flex>
      </v-layout>
    </v-container>
    <div style="z-index:0;position:absolute;bottom:-48px;right:-5px">
      <span style="font-size:90pt;font-weight:bold;color:#FFCDD2;">
        {{props.r.obj.postCount}}
      </span>
    </div>
    <v-chip
      style="position:absolute;top:0" color="red accent-1" dark small avatar
    >
      <v-avatar class="primary" dark style="margin-right:2px;">{{props.r.obj.postCount}}</v-avatar>
      個の食品を辛さ比較
    </v-chip>
  </v-card>
</template>

<script>
export default {
  name: 'RankCard',
  props: {
    r: Object
  }
}
</script>

<style scoped>
</style>